<template>
    <aside class="remodal avatar-remodal">
        <button data-remodal-action="close" class="remodal-close">
            <i class="material-icons">close</i>
        </button>

        <div v-if="user.foundationsIsUnlocked">
            <div class="swiper-container avatar-carousel mb--sm">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" :key="avatar.id" v-for="avatar in avatars">
                    <span class="img-circle">
                        <img :src="avatar.image"/>
                    </span>
                    </div>
                </div>

                <div class="swiper-button-prev"><i class="material-icons">keyboard_arrow_left</i></div>
                <div class="swiper-button-next"><i class="material-icons">keyboard_arrow_right</i></div>
            </div>

            <h4 class="modal__title">Change avatar</h4>

            <p class="mb--30">Choose a profile picture</p>
            <a @click="updateUserAvatar" class="btn btn--block btn--secondary">Done</a>
        </div>

        <div v-else>
            <div class="btn btn--white btn--wrapper text--center mb--md"><img src="/img/icons/trophy-2.svg" alt=""></div>

            <h4 class="modal__title">
                Customize profile
            </h4>

            <div class="mb--30"><p>You can change your avatar and your profile colour if you complete all of the foundation achievements.</p></div>

            <a href="/#achievements" class="btn btn--block btn--secondary">Go to dashboard</a>
        </div>

    </aside>
</template>

<script>
    import {mapGetters} from "vuex"
    import api from "../../api/profile"
    import Swiper from "swiper";

    export default {
        name: "AvatarSelectorModal",
        computed: {
            ...mapGetters('auth', [
                'user',
                'isLoggedIn'
            ]),
        },
        data: () => ({
            instance: null,
            selectedId: null,
            selectedImage: null,
            avatars: null,
            swiper: null,
            options: {
                loop: true,
                slidesPerView: 3,
                centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    slideChange() {
                        window.Quiz.$emit('update-selected-avatar', this.realIndex);
                    },
                }
            }
        }),

        mounted() {
            this.instance = $(this.$el).remodal({
                hashTracking: false
            });

            this.selectedId = this.$store.state.auth.user.avatarId;
            this.selectedImage = this.$store.state.auth.user.avatar;
        },

        methods: {
            close() {
                this.instance.close()
            },

            open() {
                this.instance.open()
            },
            updateUserAvatar() {
                Quiz.$emit('update-user-avatar', {'id': this.selectedId, 'avatar': this.selectedImage})
                this.close();
            },
            async loadAvatars() {
                try {
                    let response = await api.loadAvatars()

                    this.avatars = response.data;
                } catch (error) {
                    if (error.response.status === 401) {
                        this.$store.dispatch('auth/loadUser').then(() => {
                            this.$router.push('/')
                        })
                    }

                    Quiz.$emit('user-avatars-load-error')
                }
            },
            select(avatar) {
                this.selectedId = avatar.id;
                this.selectedImage = avatar.image;
            },
            createSwiper() {
                if (! this.swiper) {
                    this.swiper = new Swiper('.avatar-carousel', this.options);
                }
            }
        },
        created() {
            this.loadAvatars();

            Quiz.$on('avatar-swiper-created', () => this.createSwiper())
            Quiz.$on('update-selected-avatar', (value) => this.select(get(this.avatars, value)))
        },
    }
</script>